import React from 'react';

/**
 * Maps a MTG mana cost token (the text between `{` and `}`) to the
 * class suffix used by the mana sprite in mana-cost.css (e.g. `W` → `sw`,
 * `W/U` → `swu`, `2/W` → `s2w`, `T` → `st`). Mirrors
 * playtest/components/assets/ManaSymbol.jsx#getManaClass but scoped to
 * this folder so we don't cross-import a playtest internal.
 */
export function getManaClass(symbol) {
    const s = (symbol || '').toLowerCase();
    if (s === 't') return 'st';
    if (s === 'q') return 'sq';
    if (/^[wubrgc]$/.test(s)) return `s${s}`;
    if (s === 'x') return 'sx';
    if (s === 'y') return 'sy';
    if (s === 'z') return 'sz';
    if (s === 's') return 'ss';
    if (s === 'e') return 'se';
    if (s.includes('/')) {
        const parts = s.split('/');
        if (parts[1] === 'p') return `s${parts[0]}p`;
        return `s${parts.join('')}`;
    }
    const num = parseInt(s, 10);
    if (!Number.isNaN(num)) return `s${num}`;
    return 's0';
}

/**
 * Replaces `{...}` tokens in a rules-text string with inline mana symbol
 * spans (drawn from mana-cost.css). Returns a React node array suitable
 * for inline rendering. Non-mana tokens pass through as plain text.
 */
export function renderManaText(text, size = 'medium') {
    if (!text) return null;
    const parts = [];
    let lastIndex = 0;
    const regex = /\{([^}]+)\}/g;
    let match;
    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        const token = match[1];
        parts.push(
            <span
                key={`mana-${match.index}`}
                className={`mana ${size} ${getManaClass(token)} manaTextIcon`}
                aria-label={token}
            />
        );
        lastIndex = regex.lastIndex;
    }
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }
    return parts;
}
